import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useShowroomLocator, { validateZipcodeInput } from 'hooks/useShowroomLocator';
import ShowroomLocatorResults from './ShowroomLocatorResults';
const ShowroomLocatorContent = t0 => {
  const $ = _c(23);
  const {
    inputId: t1,
    className: t2,
    isMobile: t3
  } = t0;
  const inputId = t1 === undefined ? "showroom-zipcode" : t1;
  const className = t2 === undefined ? "" : t2;
  const isMobile = t3 === undefined ? false : t3;
  const zipInputRef = useRef();
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      zipcode: ""
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== handleSearch) {
    t5 = t6 => {
      const {
        zipcode
      } = t6;
      handleSearch(zipcode);
    };
    $[1] = handleSearch;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== inputId) {
    t6 = t7 => {
      const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      } = t7;
      return <form onSubmit={handleSubmit}><LabeledTextInput id={inputId} name="zipcode" label="Zip Code" type="text" value={values.zipcode} onChange={handleChange} onBlur={handleBlur} errorMessage={touched.zipcode && errors.zipcode ? errors.zipcode : null} maxLength="5" autoComplete="postal-code" ref={zipInputRef} className="text-sm mb-1" action={<CtaButton type="submit" data-xc="FooterShowroomSearchButton" styling="solid-button" color="brand" size="sm" className="ml-2">Search</CtaButton>} actionHasPadding={false} actionStretchHeight={true} /></form>;
    };
    $[3] = inputId;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = <Formik initialValues={t4} validate={validateZipcodeInput} onSubmit={t5}>{t6}</Formik>;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== error || $[10] !== handleCloseResults || $[11] !== hasSearched || $[12] !== isMobile || $[13] !== loading || $[14] !== stores) {
    t9 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={isMobile} />;
    $[9] = error;
    $[10] = handleCloseResults;
    $[11] = hasSearched;
    $[12] = isMobile;
    $[13] = loading;
    $[14] = stores;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleViewAll) {
    t10 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} data-xc="FooterShowroomViewAllLink" className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[16] = handleViewAll;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== className || $[19] !== t10 || $[20] !== t7 || $[21] !== t9) {
    t11 = <div className={className}>{t7}{t8}{t9}{t10}</div>;
    $[18] = className;
    $[19] = t10;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
ShowroomLocatorContent.propTypes = {
  inputId: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool
};
export default ShowroomLocatorContent;